'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.popupModeSelector = exports.selectedImageSelector = exports.selectedIconSelector = exports.firstElementIdSelector = undefined;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _reselect = require('reselect');

var _lodash = require('lodash');

var _iconsPopupConstants = require('./iconsPopupConstants');

var _elementIconConstants = require('../../../../../components/elementIcon/elementIconConstants');

var _stringUtil = require('../../../../../../common/utils/stringUtil');

var _makeStringIconDef = require('../../../../../components/elementIcon/makeStringIconDef');

var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);

var _popupOpenSelector = require('../../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

var _selectedElementsSelector = require('../../../../../element/selection/selectedElementsSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Helper functions
var filterWords = function filterWords(wordList) {
    var filterNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var filterPunctuation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return wordList.filter(function (word) {
        return (!filterNumbers || isNaN(word)) && _iconsPopupConstants.ICON_POPUP_WORD_FILTERS.indexOf(word.toLowerCase()) === -1;
    });
};

var getFirstSelected = function getFirstSelected(propertyPath) {
    return function (selectedElements) {
        return selectedElements.first() ? selectedElements.first().getIn(propertyPath) : null;
    };
};
var getFirstAttachmentData = getFirstSelected(['attachment', 'data']);
var getSelectedImage = function getSelectedImage(selection, elements) {
    return getFirstAttachmentData(selection, elements) || getFirstSelected(['content', 'image', 'regular'])(selection, elements);
};
var getSelectedIcon = getFirstSelected(['content', 'icon']);

var getFirstElementId = getFirstSelected(['id']);

// Selected property selectors
var firstElementIdSelector = exports.firstElementIdSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getFirstElementId);

// Selected property selectors
var selectedIconSelector = exports.selectedIconSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getSelectedIcon);

var selectedImageSelector = exports.selectedImageSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, getSelectedImage);

// Popup state selectors
var popupModeSelector = exports.popupModeSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return state.getIn(['app', 'popup', 'icons', 'mode']);
}, selectedImageSelector, function (popupMode, selectedImage) {
    var actualPopupMode = popupMode;
    if (!actualPopupMode) {
        actualPopupMode = selectedImage ? _iconsPopupConstants.ICON_POPUP_MODE_IMAGES : _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT;
    }
    return actualPopupMode;
});

var selectedElementTitleSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.selectedElements;
}, function (selectedElements) {
    return selectedElements && selectedElements.first().getIn(['content', 'title']);
});

var popupQuerySelector = (0, _reselect.createSelector)(popupModeSelector, selectedElementTitleSelector, function (popupMode, selectedTitle) {
    if (popupMode === _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT) {
        return selectedTitle;
    } else if (popupMode === _iconsPopupConstants.ICON_POPUP_MODE_LETTERS) {
        return _iconsPopupConstants.ICON_POPUP_MODE_LETTERS;
    }
    return popupMode;
});

var lettersSelector = (0, _reselect.createSelector)(selectedElementTitleSelector, function (selectedTitle) {
    var titleWords = (0, _stringUtil.slugify)(selectedTitle, '-').split('-');

    if (titleWords.length > 2) {
        titleWords = filterWords(titleWords, false, false);
    }

    var titleLetters = titleWords.map(function (word) {
        return isNaN(word) || word.length > _elementIconConstants.STRING_ICON_MAX_LENGTH ? word[0].toLowerCase() : word;
    });

    var iconStringList = [];

    if (titleLetters.length >= 2) {
        var combined = titleLetters.reduce(function (acc, letter) {
            return acc.length < _elementIconConstants.STRING_ICON_MAX_LENGTH ? acc + letter : acc;
        }, '');
        if (combined.length <= _elementIconConstants.STRING_ICON_MAX_LENGTH) iconStringList.push(combined);
    }

    if (titleLetters.length >= 3) {
        var combinedStartEnd = titleLetters[0] + titleLetters[titleLetters.length - 1];
        if (combinedStartEnd.length <= _elementIconConstants.STRING_ICON_MAX_LENGTH) iconStringList.push(combinedStartEnd);
    }

    titleLetters.forEach(function (letter) {
        iconStringList.push(letter);
    });

    _iconsPopupConstants.ICON_POPUP_NUMBERS_LIST.forEach(function (letter) {
        if (titleLetters.indexOf(letter) !== -1) return;
        iconStringList.push(letter);
    });

    var stringIcons = (0, _lodash.uniq)(iconStringList).map(function (letter) {
        return (0, _makeStringIconDef2.default)(letter);
    });
    return Immutable.List(stringIcons);
});

var iconListSelector = (0, _reselect.createSelector)(popupModeSelector, popupQuerySelector, selectedElementTitleSelector, lettersSelector, function (state, ownProps) {
    return state.getIn(['app', 'popup', 'icons', 'searchResults']);
}, function (popupMode, popupQuery, selectedTitle, lettersList, searchResults) {
    switch (popupMode) {
        case _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT:
            return searchResults.get(popupQuery) && searchResults.get(popupQuery).slice(0, 8).concat(lettersList);
        case _iconsPopupConstants.ICON_POPUP_MODE_LETTERS:
            return lettersList.concat(_iconsPopupConstants.STRING_ICONS);
        default:
            return searchResults.get(popupQuery);
    }
});

var iconPopupModeListSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.selectedElements;
}, selectedElementTitleSelector, function (state, ownProps) {
    return state.getIn(['app', 'popup', 'icons', 'elementSearches']);
}, selectedImageSelector, function (selectedElements, selectedTitle, elementSearches, selectedImage) {
    if (!selectedTitle) return;

    var popupModeList = [{ slug: _iconsPopupConstants.ICON_POPUP_MODE_DEFAULT, title: 'Recommended' }];
    var customList = [];

    var splitTitle = filterWords(selectedTitle.split(' ')).map(function (word) {
        return word.replace(/[.,\/"'\^&\*;:{}=\-_`~()]/g, '');
    }).filter(function (word) {
        return word.length > 0;
    });

    if (splitTitle.length > 1) {
        splitTitle.forEach(function (part) {
            customList.push({
                slug: part,
                title: part
            });
        });
    }

    var firstEl = selectedElements.first().get('id');
    var savedSearches = elementSearches.get(firstEl) && elementSearches.get(firstEl).valueSeq().toArray();

    if (savedSearches) {
        savedSearches.forEach(function (q) {
            customList.push({
                title: q,
                slug: q
            });
        });
    }

    customList = customList.slice(-(_iconsPopupConstants.ICON_POPUP_MODE_LIST_MAX - 3));
    popupModeList = popupModeList.concat(customList);

    popupModeList.push({ slug: _iconsPopupConstants.ICON_POPUP_MODE_LETTERS, title: 'Letters & numbers' });

    var imageModeTitle = selectedImage ? 'Custom image' : 'Upload an image';
    popupModeList.push({ slug: _iconsPopupConstants.ICON_POPUP_MODE_IMAGES, title: imageModeTitle });
    return popupModeList;
});

var iconPopupSelector = (0, _reselect.createSelector)((0, _popupOpenSelector2.default)('icon'), popupQuerySelector, iconPopupModeListSelector, iconListSelector, function (isActive, popupQuery, modeList, iconList) {
    if (!isActive) return { isActive: isActive };

    return {
        isActive: isActive,
        popupQuery: popupQuery,
        modeList: modeList,
        iconList: iconList
    };
});

exports.default = iconPopupSelector;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/iconPopupSelector.js
// module id = 789
// module chunks = 0